<style scoped lang="scss">
  .wrap-tec{
    margin-bottom: 0;
    .container{
      width: 1200px;
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
    .cons{
      display: none;
    }
    .compose-type, .service{
      background: #F6FAFD;
      margin-top: 100px;
      padding-bottom: 80px;
      .c-title{
        padding-top: 60px;
      }
    }
  }
  @media screen and (max-width: 640px){
    .wrap-tec .compose-type {
      margin-top: 20px!important;
      padding-bottom: 30px!important;
    }
    .mr42{
      margin-left: auto;
      margin-right: auto;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
    .wrap-tec .effect-lists li{
      height: 180px!important;
    }
    //.wrap-tec .effect-lists li:first-child{
    //  padding-top: 20px;
    //}
    .wrap-tec .service{
      margin-top: 30px!important;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  引物合成-->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <!-- alt : 擎科生物-引物合成-全国近20个合成实验室，为您提供便捷高品质的合成服务-->
      <img src="@/assets/images/banner_2.png" class="img-fluid" alt="引物合成">
      <div class="info">
        <div class="container">
          <h1>近20个合成实验室</h1>
          <h2 class="mt10">为您提供 便捷高品质的合成服务</h2>
          <el-button class="mt40 mr42" size="mini" @click="toOrder">立即合成</el-button>
          <el-button class="mt40 mr41"  @click="toOrder">立即合成</el-button>
        </div>
      </div>
    </div>
<!--    <div class="banner">-->
<!--      <el-carousel :interval="5000" arrow="never" :height="bannerHeight">-->
<!--        <el-carousel-item v-for="item in 3" :key="item">-->
<!--          <img src="@/assets/images/banner_2.png" class="img-fluid" style="height:100%;">-->
<!--          <div class="info">-->
<!--            <div class="container">-->
<!--              <h1>近20个合成实验室</h1>-->
<!--              <h2 class="mt10">为您提供 便捷高品质的合成服务</h2>-->
<!--              <el-button class="mt30" @click="toOrder">立即合成</el-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <div v-if="!$route.meta.invisible && !$route.meta.invisibles">
    <div>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="c-title">寡核苷酸合成</div>
      <div class="container con1">
        <el-row type="flex" align="bottom">
          <el-col :span="12">
            <img src="@/assets/images/compose_1.png" class="img-fluid" alt="擎科生物-引物合成服务
">
          </el-col>
          <el-col :span="12">
            <div class="required">
              <p class="desc">擎科生物通过多年的业务布局，形成了遍布全国近20个城市的引物合成实验室，可快速地为客户提供高品质的的引物合成服务。擎科生物在服务体系上不断优化，先后开发出液体引物，圆点标签等多样化服务，方便了广大科研及企业用户。同时，我们特别注重质量体系的建设，擎科生物拥有从引物合成原材料，DNA合成仪制造到引物合成纯化新工艺的整套产业链，可对生产各环节进行严格的把控，以满足不同客户对引物合成的质量要求。</p>
              <p class="mt10">合成类型包含：<span class="text-primary">常规引物合成、修饰引物/探针合成、RNA合成</span></p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="compose-type">
      <en-title title="合成类型" />
      <p class="title-desc">
        擎科生物可提供多种类型的寡核苷酸合成服务,包括引物合成、修饰引物/探针合成和RNA合成服务，也可为您提供前期的引物设计服务，为生物医药、分子诊断、基因编辑，核酸药物以及现代农业等领域提供技术支持。      
      </p>
      <div class="container con1">
        <ul class="effect-lists con">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/images/sevice_${item.img}${currentType===index ? '' : '_active'}.png`">
            <p>{{item.name}}</p>
          </li>
        </ul>
        <ul class="effect-lists cons cons1" style="margin-top: 20px;">
          <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)" style="margin-left: auto!important;margin-right: auto!important;">
            <img :src="`/static/images/sevice_${item.img}${currentType===index ? '' : '_active'}.png`">
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <en-title title="服务详情"></en-title>
      <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
    </div>
    <div>
      <div class="c-title">亚磷酰胺合成法原理</div>
      <div class="container con1">
        <el-row :gutter="40" type="flex" align="bottom">
          <el-col :span="11">
            <div class="desc mb30">
              <p>1、脱保护：将连接在固相载体CPG上核苷酸与三氯乙酸反应，脱去其5'-OH的保护基团DMT，获得游离的5'-OH。</p>
              <p>2、耦连：将亚磷酰胺保护核苷酸单体，与活化剂四氮唑混合，得到核苷亚磷酸活化中间体，它的3'端被活化，5'-OH仍然被DMT保护，将活化好的中间体与溶液中游离的5'-羟基发生缩合反应。</p>
              <p>3、盖帽：缩合反应中可能有极少数5'-羟基没有参加反应(少于2%)，用乙酸酐和1-甲基咪唑终止其后继续发生反应，这种短片段可以在纯化时分离掉。</p>
              <p>4、氧化：在氧化剂碘的作用下，亚磷酰形式转变为更稳定的磷酸三酯。</p>
            </div>
          </el-col>
          <el-col :span="13">
            <img src="@/assets/images/compose_2.png" alt="擎科生物-引物合成-亚磷酰胺合成法原理
" style="width:100%">
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <div class="c-title">引物常见问题</div>
      <div class="container container1 con1">
        <div class="questions questions1">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="Q-1、合成DNA溶液在室温下放置了数天，还可以使用吗?" name="1">
              <p>溶液中的Oligo DNA常温下数天（3-4天）应该没问题，不建议放置一个星期以上。其寿命受溶液中的菌体、核酸酶等的影响。
              </p>
            </el-collapse-item>
            <el-collapse-item title="Q-2、怎样理解测定的OD值?" name="2">
              <p>进行OD值测定时，分光光度计上显示的数值为每毫升溶液中的OD值。当测定200 ml溶液中的OD值为1.5时，溶液整体的OD量应该为多少？此时的OD值 = 1.5 OD/ml × 0.2 ml = 0.3 OD。
              </p>
            </el-collapse-item>
            <el-collapse-item title="Q-3、怎样对合成的DNA制品进行定量?" name="3">
              <p>DNA的量与260 nm处的吸光度值（OD值）成正比，因此使用紫外分光光度计定量是可靠的。1个OD值的合成DNA的重量约为33 ug。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-4、合成Oligo DNA应怎样保存?" name="4">
              <p>保存合成的Oligo应该注意以下几点：</p>
              <p>(1).干燥制品很稳定，常温下数个月无问题。但为保证万无一失，放置于-20℃保存为好。</p>
              <p>(2).溶解后的溶液DNA短期内（1-2周）使用可放置在4℃下保存，长期保存请放置于-20℃。溶解DNA时，请注意使用无菌、无核酸酶的水或TE Buffer。</p>
              <p>(3).荧光标记引物请避光保存。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-5、制品溶解后发现有少许沉淀，会影响实验结果吗?" name="5">
              <p>所有的制品纯化后都要进行脱盐，脱盐是使用C18柱进行的，偶而会有微量的树脂溢出而进入制品。树脂不影响反应结果，请稍许离心后取上清使用。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-6、为什么PAGE级和高纯度级制品的提供量比其他公司少?" name="6">
              <p>无论是PAGE纯化，还是HPLC纯化，增大每次的纯化量会大大降低制品的纯度。所以，为了保证制品质量，我们一般把每次的纯化量控制在2 OD左右。大OD量的提供对提高纯度是不现实，不科学的做法。一般，1 OD的20mer的DNA制品 (约5 nmol)，可以进行200-400 次的PCR反应 (50ml体系)，以及1,400次的测序反应。因此，2 OD 的DNA量可以足够进行一般的实验工作。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-7、我公司的DNA制品包装中为什么不提供电泳照片?" name="7">
              <p>进行过Oligo DNA PAGE电泳的人员都知道，同一OD量的不同序列的DNA制品电泳时的泳带亮度（清晰度）是不一样的。原因在于EB等染色剂的染色是渗透至DNA的双链之间的，而合成的Oligo DNA是单链，Oligo DNA自身形成的立体结构越复杂，EB的染色就越容易，DNA带也就越亮。相反，有一些Oligo DNA由于不形成立体结构，根本就不为EB所染色。因此，我们认为有些公司对所有产品都提供差不多同一亮度的制品的电泳照片是非常不现实的做法。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-8、使用3%的Agarose凝胶电泳合成Oligo DNA制品，发现有很多条泳带，为什么?" name="8">
              <p>Oligo DNA的电泳一定要使用变性PAGE电泳。Oligo DNA是单链DNA，容易形成复杂的立体结构，因此进行Agarose电泳时，容易出现多条泳带（更无法用Agarose电泳进行定量了)。
              </p>
            </el-collapse-item>
            <el-collapse-item title="Q-9、进行PAGE电泳时，长度完全一样的Oligo DNA为什么泳带不在同一位置?" name="9">
              <p>Oligo DNA的电泳一定要使用变性PAGE电泳。Oligo DNA是单链DNA，容易形成复杂的立体结构，因此进行Agarose电泳时，容易出现多条泳带（更无法用Agarose电泳进行定量了)。</p>
              <p>(1). A、G、C、T的组份不同，电泳速度不同；</p>
              <p>(2). DNA的立体结构不同，电泳速度不同。这种情况在Oligo DNA越短时越容易发生，长链Oligo DNA之间差别较小。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-10、PCR产物经克隆后测序发现，引物处的碱基有错误，为什么?" name="10">
              <p>(1). 合成机管路的瞬时阻堵，造成化学反应的瞬间中断，其结果可能会发生单个(或一部分)碱基的缺失。</p>
              <p>(2). 计算机程序失灵，控制错误合成。</p>
              <p>(3). 合成过程中，碱基附加至DNA片段之前，碱基和碱基之间发生了偶联，然后再附加到了DNA片段上，造成多碱基现象。</p>
              <p>(4). 合成时碱基G可能会转化成烯醇异构体，此时进行PCR反应时G会转变成A。</p>
              <p>(5). 合成过程中的脱嘌呤作用，对脱嘌呤后的碱基DNA聚合酶不能识别，此时可能观察到A或G的缺失。嘌呤含量越高，就越容易发生这种情况。</p>
              <p>(6). 不完全的脱保护结果。通常C脱得快，G脱得慢。不完全脱保护会发生碱基缺失。</p>
              <p>(7). 合成过程中的Capping（盖帽）反应不完全，使短片段DNA继续参与合成，造成碱基缺失。 应该说，上述这些情况发生的可能性都极低。然而，合成的DNA链越长，发生这种情况的机率也就越大。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-11、PCR产物经克隆后测序发现，引物处的碱基有错误，怎么办?" name="11">
              <p>(1). 因为引物纯度不可能是100%，因此，挑选克隆时，有可能挑选了杂质引物扩增出的PCR产物的克隆。此时，请重新挑选一个克隆测序，也许结果会变好。</p>
              <p>(2). 如果挑选2 ~ 3个克隆测序情况还没改观，我们会免费重新合成引物。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-12、进行蛋白表达实验数个月不成功，后经测序发现引物处有错误，怎么办?" name="12">
              <p>(1). 表达实验之前一定要对DNA序列进行验证，这是实验的常识。</p>
              <p>(2). 我们可以免费重新合成引物。</p>
              <p>(3). 如进行索赔时，按国际行业惯例，索赔范围限于制品价格范围之内。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-13、怎样才能保证Oligo DNA的正确性?" name="13">
              <p>(1). 合成Oligo DNA时，选用高纯度级制品。</p>
              <p>(2). 避免使用大于50mer的长链Oligo DNA，最好选用小于35mer的合成DNA制品。</p>
              <p>(3). 进行克隆实验时，每次克隆都须进行测序验证，以保证序列的正确性，然后再进行进一步实验。进行蛋白表达实验时，尤其需要注意。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-14、Oligo DNA最长可以合成多少个碱基?" name="14">
              <p>以每步反应效率为99%进行计算，粗略计算合成到100个碱基时，目的DNA片段的比例便为0 (精确数为37.0%)，要想保证合成DNA的碱基100%正确，Oligo DNA的长度最好不要超过70mer，80mer以上要想保证一个碱基不错就非常危险了，须十分注意。
              </p>
            </el-collapse-item>
            <el-collapse-item title="Q-15、一般的合成Oligo DNA的5'和3'末端有Q吗? (Q为修饰)" name="15">
              <p>没有，5'和3'末端均为-OH基。如需要加Q，订货时请特别注明，此时需收取加Q (Q修饰) 的费用。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-16、合成的引物进行PCR反应时无目的带，怎么办?" name="16">
              <p>(1). 引物和模板是否配对，同源性有多大?</p>
              <p>(2). 引物本身是否有立体结构，或者二条引物之间是否形成高次结构?</p>
              <p>(3). PCR反应用试剂是否能正常工作?</p>
              <p>(4). PCR仪是否工作正常?</p>
              <p>(5). PCR反应条件是否合适?</p>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="c-title">服务特色</div>
      <div class="container">
        <ul class="lists">
          <li>
            <img src="@/assets/images/primer_service_1.png" alt="擎科生物-引物合成服务优势-完整合成产业链">
            <h4>完整产业链</h4>
            <p>具备生产DNA合成原料、DNA合成仪、DNA合成纯化新工艺。</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_1.png" alt="擎科生物-引物合成服务优势-全国近20个实验基地分布">
            <h4>实验基地</h4>
            <p>全国多个城市都有实验基地，近距离的提供服务</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_3.png" alt="擎科生物-引物合成服务优势-快捷交付">
            <h4>快捷交付</h4>
            <p>常规引物当日下单，次日送达（仅满足有实验基地的城市）</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_2.png" alt="擎科生物-引物合成服务优势-质量保证">
            <h4>质量可靠</h4>
            <p>严格的质控，通过ISO 9001:2015,ISO 13485:2016</p>
          </li>
          <li @click="toOrder" class="pointer">
            <img src="@/assets/images/gen_icon_4.png" alt="擎科生物-引物合成服务优势-线上快捷订购系统">
            <h4>快捷订购</h4>
            <p>线上订单服务系统</p>
          </li>
        </ul>
<!--        <ul class="lists" style="margin-top: -50px;">-->
<!--          <li v-for="item in 5" :key="item"><img :src="`/static/images/service_${item}.png`"> </li>-->
<!--        </ul>-->
      </div>
    </div>
    <!-- 订购与咨询 -->
    <new-consult type="primer" enTitle="" phoneNumber="400-668-3730 转2" :typeList="['orderOnline','telePhone','download','email']"></new-consult>

    <!-- <qk-consult type="primer"/> -->
    <!--在线订购-->
    <qk-online-order @order="toOrder"/>
    </div>
  </div>
</template>

<script>
import OnlineOrder from '@/components/onlineOrder'
import bread from "@/components/bread"
import GeneDetailTable from '@/views/products/gene-components/geneDetailTable'
export default {
  components: {
    bread,
    GeneDetailTable,
    'qk-online-order': OnlineOrder
  },
  data () {
    return {
      currentType: -1,
      types: [
        {name: '常规引物合成', img: '4', ref: '/tec/compose1'},
        {name: '修饰引物/探针合成', img: '5', ref: '/tec/compose2'},
        {name: 'RNA合成', img: '8', ref: '/tec/compose3'},
      ],
      activeNames: [],
      bannerHeight: '',
       tableColumn:[
        {
          label:'合成类型',
          prop:'type',
        },
        {
          label:'产品名称',
          prop:'name',
        },
        {
          label:'合成长度（nt）',
          prop:'length',
        },
        {
          label:'主要应用领域',
          prop:'application',
        },
      ],
      tableData:[
        {
          type:'常规Oligo合成',
          name:'普通Oligo',
          length:'5~60',
          application:'分子生物学',
        },
        {
          type:'',
          name:'长链Oligo',
          length:'60+',
          application:'合成生物学与基因功能研究',
        },
        {
          type:'',
          name:'公斤级Oligo',
          length:'定制',
          application:'新药筛选与药物生产',
        },
        {
          type:'修饰Oligo合成',
          name:'qPCR Probe',
          length:'15~60',
          application:'qPCR实验与IVD',
        },
        {
          type:'',
          name:'NGS Oligo',
          length:'定制',
          application:'NGS建库与多重PCR',
        },
        {
          type:'',
          name:'Custom DNA Oligo',
          length:'定制',
          application:'生命科学研究',
        },
        {
          type:'RNA Oligo合成',
          name:'siRNA',
          length:'20~25',
          application:'功能研究与核酸药物',
        },
        {
          type:'',
          name:'sgRNA',
          length:'定制',
          application:'基因编辑',
        },
        {
          type:'',
          name:'Custom RNA Oligo',
          length:'定制',
          application:'生命科学研究',
        },

      ],
    }
  },
  beforeMount () {
    this.bannerHeight = document.body.clientWidth * 450 / 1440 + 'px'
  },
  methods: {
    toOrder () {
      this.$router.push('/tec/order_primer')
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   
      if (columnIndex === 0 ) {
          return {
            rowspan: row.type ? 3 : 0,
            colspan: row.type ? 1 : 0
          }
        
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/compose.vue